<template>
  <VueDatePicker :key="datePickerKey" class="hrm_range_picker" :ui="{ menu: 'hrm_range_picker_menu' }"
    v-model="pickerDate" :enable-time-picker="false" :placeholder="placeholder" :format="format"
    :position="pickerPosition" :teleport="true" week-picker auto-apply @update:model-value="selectedDate"
    hide-input-icon>
  </VueDatePicker>
</template>
<script setup>
import VueDatePicker from "@vuepic/vue-datepicker";
import { ref, defineEmits, onMounted } from 'vue';

const props = defineProps({
  pickerPosition: {
    type: String,
    default: 'center'
  },
  placeholder: {
    type: String,
    default: 'Select Week Days'
  },
  startDate: {
    type: String,
  },
  endDate: {
    type: String,
  }
})
const emits = defineEmits('getDateRange')
const pickerDate = ref();
const datePickerKey = ref(1);

const selectedDate = (date) => {
  if (!date) {
    emits('getDateRange', null);
  } else {
    emits('getDateRange', date);
  }
}

const format = (date) => {
  if (!date) return false;
  const selectedDate = new Date(date);
  const day = selectedDate.getDay(); // 0 (Sun) to 6 (Sat)

  // Calculate start of the week (Monday as start of the week)
  const start = new Date(selectedDate);
  start.setDate(selectedDate.getDate() - ((day + 6) % 7)); // adjust if Monday is start

  // End of the week (Sunday)
  const end = new Date(start);
  end.setDate(start.getDate() + 6);

  const formatDate = (d) => {
    const dd = d.getDate().toString().padStart(2, '0');
    const mm = (d.getMonth() + 1).toString().padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

  return `${formatDate(start)} To ${formatDate(end)}`;
}

const clearAndEmit = () => {
  pickerDate.value = null;
  datePickerKey.value += 1;
  emits('getDateRange', null);
}
</script>

<style>
.hrm_range_picker .dp--clear-btn {
  margin-right: 10px !important;
}

.hrm_range_picker_menu .dp--preset-dates {
  width: 200px !important;
}

.hrm_range_picker_menu .dp--preset-dates button {
  font-size: 14px !important;
  font-weight: bold !important;
  padding: 3px 10px !important;
}
</style>